<script setup lang="ts">
import { data } from './data'
import { useDetectOS } from '~/composables/useDetectOS'

const { isAppleEcosystem } = useDetectOS()
</script>

<template>
    <div
        class="w-full rounded-2xl border-b-2 border-l-2 border-plus-lp-dark-blue-300 bg-[url('https://api.plus.pl/file/images_lp/plus_acse_landingpages/Footer/Rectangle98.webp')] bg-[100%_0] bg-no-repeat object-cover px-4 py-6 font-figtree xl:max-h-[539px] xl:min-h-[548px] xl:max-w-[391px] xl:border-none xl:bg-[url('https://api.plus.pl/file/images_lp/plus_acse_landingpages/IPlus/T%C5%82o_(2).webp')] xl:bg-[length:100%] xl:px-12 xl:py-11"
    >
        <div class="flex justify-between">
            <img
                src="https://api.plus.pl/file/images_lp/plus_acse_landingpages/IPlus/logos.webp"
                alt="plus"
                class="xl:hidden"
            />
            <img
                src="https://api.plus.pl/file/images_lp/plus_acse_landingpages/IPlus/Frame_48096302.webp"
                alt="points"
                class="h-6 xl:hidden"
            />
            <img
                src="https://api.plus.pl/file/images_lp/plus_acse_landingpages/IPlus/logos_(2).webp"
                alt="plus"
                class="hidden xl:block"
            />
        </div>
        <div class="bg-dark-blue-300 my-6 h-px w-full" />
        <div class="flex justify-between">
            <span
                class="lp-label-sm xl:hidden"
                v-html="data.subtitle"
            />
            <span
                class="lp-heading-md hidden xl:block"
                v-html="data.subtitle"
            />
            <a
                target="_blank"
                :href="
                    isAppleEcosystem
                        ? 'https://apps.apple.com/pl/app/iplus/id974674099?l=pl'
                        : 'https://play.google.com/store/apps/details?id=pl.plus.plusonline&hl=pl&pli=1'
                "
                class="xl:hidden"
            >
                <img
                    :src="
                        isAppleEcosystem
                            ? 'https://api.plus.pl/file/images_lp/plus_acse_landingpages/IPlus/Variant=App_Store.webp'
                            : 'https://api.plus.pl/file/images_lp/plus_acse_landingpages/IPlus/Variant=Google_Play.webp'
                    "
                    :alt="isAppleEcosystem ? 'AppStore' : 'GooglePlay'"
                />
            </a>
        </div>
        <span class="mt-4 hidden text-base font-normal xl:block">{{ data.info }}</span>
        <img
            src="https://api.plus.pl/file/images_lp/plus_acse_landingpages/IPlus/Frame_48096302_(1).webp"
            alt=""
            class="mt-3 hidden xl:block"
        />
        <img
            src="https://api.plus.pl/file/images_lp/plus_acse_landingpages/IPlus/iPlus.webp"
            alt="qr-code"
            class="mt-5 hidden size-[144px] rounded-md xl:block"
        />
    </div>
</template>
